import { useMemo } from "react";
import useAccount from "@/modules/account/hooks/useAccount";
import { useIsAdmin } from "@/modules/account/hooks/useIsAdmin";
import { ReadContractorVisit } from "@/types/contractorVisit";
import { SYSTEM_ROLE_CODE } from "@/schemas/user";

const CONTRACTOR_VISIT_EDIT_RESTRICTED_ROLE_CODES: string[] = [
  SYSTEM_ROLE_CODE.VICE_STORE_COORDINATOR, // ZKH
  SYSTEM_ROLE_CODE.STORE_COORDINATOR, // KH
  SYSTEM_ROLE_CODE.SUPERVISOR, // SV
  SYSTEM_ROLE_CODE.REGIONAL_REPRESENTATIVE, // PR
  SYSTEM_ROLE_CODE.REGIONAL_DIRECTOR, // DR
];

export const useCanEditContractorVisitFields = () => {
  const { account } = useAccount();
  const isAdmin = useIsAdmin();

  return useMemo(() => {
    const isInRestrictedRoles =
      !!account?.system_role_code &&
      CONTRACTOR_VISIT_EDIT_RESTRICTED_ROLE_CODES.includes(
        account.system_role_code,
      );

    const canEditPrRestrictedFields = (row: ReadContractorVisit) =>
      row.editable_by_pr !== false || !isInRestrictedRoles;

    return {
      canEditDateTimeRange: (row: ReadContractorVisit) => {
        if (!row.edit_allowed) return false;
        if (isAdmin) return true;

        return (
          row.hours_editable_by_contractor && canEditPrRestrictedFields(row)
        );
      },
      canEditRrPlannedDuration: (row: ReadContractorVisit) => {
        if (!row.edit_allowed) return false;
        if (isAdmin) return true;

        return canEditPrRestrictedFields(row);
      },
      canEditSuggestedTimes: (row: ReadContractorVisit) =>
        Boolean(row.edit_allowed),
    };
  }, [account?.system_role_code, isAdmin]);
};
